import { Box, Button, Checkbox, Dialog, FormControl, IconButton, MenuItem, Select, TextField, Typography, Tooltip, styled, Switch, FormControlLabel, Card, CardContent, Tabs } from "@mui/material";
import { memo, useCallback, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";

import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
//import { onChange } from "store/slices/fbs-fbo";
import { delFts, getFile, post, postImage } from "api/apiBridges/httpBridge";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { get } from "api/apiBridges/httpBridge"
import { useLocalNotifications } from "components/Events";
import { SelectProductTocopy } from "components/EIComponents/ProductInfo";
import ClassicSearch from "components/classicSearch";
import { colors } from 'styles/colors';
import usePreventDoubleClick from "components/AntiDBC";
import { SocketContext } from "components/socketLib/ConnectorSocket";
import { onChangeUploadImage } from "store/slices/uploadImage";
import NoPhoto from '../images/others/noPhoto.png';
import { CancelButton, NumInput, NumInputDesign, OKButton, TextInput, TextInputDesign, TextNumInput } from "components/EIComponents/LittleComponents";
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { ShowModal } from "components/Modal";
import { BarcodeSelect, getNextItem, ImageFormatProduct, MPTab, ProductMoreInfoProducts, UploadQrButton, UploadTechTaskButton } from "utils/formatters";
import { buttonColor, buttonColorHover, hoverStyle, hoverStyleTransformOnly, iconColor, warningTextColor } from "styles/main";
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate, useParams } from "react-router-dom";
import { useDataContextDeal } from "actions/contextDealClient";
import EditIcon from '../images/others/EditIconGreen.png';
import { ChooseProducts } from "components/ChooseProducts";
import { useVirtualizer } from "@tanstack/react-virtual";
import { fetchAllProductsData } from "utils/productsData";

export function MyProductsModern() {
    
    const ds = useMemo(() => getDataSource('ClientProductsModern'), []);
    
    /** @type {[Array<any>, Function]} */ 
    const [dataWB, setDataWB] = useState([]);
    
    /** @type {[Array<any>, Function]} */ 
    const [dataOZON, setDataOZON] = useState([]);
    
    /** @type {[Array<any>, Function]} */ 
    const [dataCUSTOM, setDataCUSTOM] = useState([]);
    
    /** @type {[any, Function]} */ 
    const [customMap, setCustomMap] = useState(undefined);

    /** @type {[Array<any>, Function]} */ 
    const [data, setData] = useState([]);

    // const [data, setData] = useState([]);
    const { user_id, company_id} = useSelector(
            loginSelector
        );

    const [loadingData, setLoadingData] = useState(true);
    const [loading, setLoading] = useState(true);

    /** @type {[any, Function]} */ 
    const [openProductDialog, setOpenProductDialog] = useState(undefined);
    /** @type {[any, Function]} */ 
    const [openLinkDialog, setOpenLinkDialog] = useState(undefined);
    

    //Настройки Фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
        }
    );
        
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();

    const used = useRef({wb: new Set(), ozon: new Set()});

    const ROW_HEIGHT = 160; // финальная высота строки включая gap
    /** @type {any} */
    const parentRef = useRef(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setLoadingData(true);

        try {
            const {
                dataWB: wb,
                dataOZON: ozon,
                dataCUSTOM: custom,
                customMap: cmap,
                data: merged,
                used: usedSets,
            } = await fetchAllProductsData({
                user_id,
                company_id,
                showNotification,
            });

            setDataWB(wb);
            setDataOZON(ozon);
            setDataCUSTOM(custom);
            setCustomMap(cmap);
            used.current = usedSets;
            setData(merged);
        } catch (err) {
            console.error("fetchData error:", err);
            setData([]);
        } finally {
            setLoadingData(false);
            setLoading(false);
        }
    }, [user_id, company_id, showNotification]);

    useEffect(() => {
        fetchData();
    }, []);

    // useEffect(() => {
    //     if (!loadingData) {
    //         setLoading(true)
    //         let res = []
    //         const tmpusedWB = new Set();
    //         const tmpusedOZON = new Set();
    //         const wbByBarcode = new Map(
    //             dataWB.map(item => [item.size.barcode, item])
    //         );

    //         const ozonByBarcode = new Map(
    //             dataOZON.map(item => [item.size.barcode, item])
    //         );

    //         for (let item of dataCUSTOM) {
    //             if (customMap[item.size.barcode]) {
    //                 let wb = wbByBarcode.get(customMap[item.size.barcode].wb)
    //                 let ozon = ozonByBarcode.get(customMap[item.size.barcode].ozon)
    //                 if (wb) {tmpusedWB.add(wb.size.barcode)}
    //                 if (ozon) {tmpusedOZON.add(ozon.size.barcode)}
    //                 res.push({wb, ozon, main: item})
    //             }
    //             else {res.push({wb:undefined, ozon:undefined, main: item})}
    //         }
    //         used.current = {wb: tmpusedWB, ozon: tmpusedOZON}
    //         setData(res)
    //         setLoading(false)
    //     }
    // }, [loadingData]);

    useOn('updateCountPages', ($data) => {
        if (!$data) return;

        setData((prev) => {
            const index = prev.findIndex(
                (el) => el.main.size.barcode === $data.size
            );
            if (index === -1) return prev;

            const next = prev.slice();          // копируем только массив (не элементы)
            const target = prev[index];
            next[index] = {
                ...target,
                main: {
                    ...target.main,
                    size: { ...target.main.size, countQr: $data.count },
                    qrcode: { ...target.main.qrcode, count: $data.count },
                },
            };
            return next;
        });
    });

    const CUCustomProduct = async ($data, id = 0) => {
        setOpenProductDialog(undefined)
        setLoading(true)
        if (id === 0) {//Создаем
            await post("custom_product/create", { ...$data, client_id: user_id });
        }
        else {//Обновляем
            await post("custom_product/update", { ...$data, client_id: user_id });
            
        }
        fetchData()

    };

    const saveLink = async (barcode, main, market) => {
        setOpenLinkDialog(undefined)
        setLoading(true)
        if (customMap[main]) {
            let obj = {
                id: customMap[main].id,
                wb_barcode: customMap[main].wb,
                ozon_barcode: customMap[main].ozon,
                custom_barcode: main,
            }
            obj[`${market}_barcode`] = barcode
            await post('Barcode_search/update', obj);
        } else {
            let obj = {
                wb_barcode: undefined,
                ozon_barcode: undefined,
                custom_barcode: main,
                user_id
            }
            obj[`${market}_barcode`] = barcode
            await post("Barcode_search/create", obj)
        }
        fetchData()
    }

    const importFromMarket = async (M) => {
        setLoading(true)
        switch(M) {
            case 'wb': {
                let resPR = []
                let resLinks = []
                for (let item of dataWB) {
                    let obj = {
                        photo: item.data.photo,
                        title: item.data.title,
                        color: item.data.color,
                        material: item.data.material,
                        size: item.size.title,
                        vendorCode: item.data.vendorCode,
                        barcode: item.size.barcode,
                        url: '',
                        brand: item.data.brand,
                        dimensions: {
                            length: item.data.dimensions.length,
                            height: item.data.dimensions.height,
                            width: item.data.dimensions.width
                        },
                        client_id: user_id
                    }
                    resPR.push(obj)
                    resLinks.push({
                        wb_barcode: item.size.barcode,
                        custom_barcode: item.size.barcode,
                        ozon_barcode: undefined,
                        user_id
                    })
                }
                await post("custom_product/createMass", {list:resPR});
                await post("Barcode_search/create", resLinks)
                break
            }
            case 'ozon': {
                let resPR = []
                let resLinks = []
                for (let item of dataOZON) {
                    let obj = {
                        photo: item.data.photo,
                        title: item.data.title,
                        color: item.data.color,
                        material: item.data.material,
                        size: item.size.title,
                        vendorCode: item.data.vendorCode,
                        barcode: item.size.barcode,
                        url: '',
                        brand: item.data.brand,
                        dimensions: {
                            length: item.data.dimensions.length,
                            height: item.data.dimensions.height,
                            width: item.data.dimensions.width
                        },
                        client_id: user_id
                    }
                    resPR.push(obj)
                    resLinks.push({
                        wb_barcode: undefined,
                        custom_barcode: item.size.barcode,
                        ozon_barcode: item.size.barcode,
                        user_id
                    })
                }
                await post("custom_product/createMass", {list:resPR});
                await post("Barcode_search/create", resLinks)
                break
            }
        }
        fetchData()
    }
    
    const filteredData = useMemo(() => {
        if (!checked || !filter) {
            return data;
        }

        const query = filter.toLowerCase();

        return data.filter((el) => {
            const active = filterFields;

            // Проверяем совпадения по основным полям
            const matchesTitle = 
                active.title.active &&
                (
                    (el.main.data?.title && String(el.main.data.title).toLowerCase().includes(query)) ||
                    (el.wb?.data?.title && String(el.wb.data.title).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.title && String(el.ozon.data.title).toLowerCase().includes(query)) 
                )

            const matchesBrand = 
                active.brand.active &&
                (
                    (el.main.data?.brand && String(el.main.data.brand).toLowerCase().includes(query)) ||
                    (el.wb?.data?.brand && String(el.wb.data.brand).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.brand && String(el.ozon.data.brand).toLowerCase().includes(query)) 
                )

            const matchesVendorCode = 
                active.vendorCode.active &&
                (
                    (el.main.data?.vendorCode && String(el.main.data.vendorCode).toLowerCase().includes(query)) ||
                    (el.wb?.data?.vendorCode && String(el.wb.data.vendorCode).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.vendorCode && String(el.ozon.data.vendorCode).toLowerCase().includes(query)) 
                )

            // Проверяем, есть ли среди штрихкодов хотя бы одно совпадение
            const matchesBarcode = 
                active.barcode.active &&
                (
                    el.main.size.barcodes.some(bel => String(bel).toLowerCase().includes(query)) || 
                    el.wb?.size.barcodes.some(bel => String(bel).toLowerCase().includes(query)) ||
                    el.ozon?.size.barcodes.some(bel => String(bel).toLowerCase().includes(query))
                )

            return matchesTitle || matchesBrand || matchesVendorCode || matchesBarcode
                
        })
    }, [data, checked, filter, filterFields]);

    const handleEditProduct = useCallback((product) => {
        setOpenProductDialog(product);
    }, []);

    const handleEditLink = useCallback((market, selected, main) => {
        let marketMap = {
            'wb': dataWB,
            'ozon': dataOZON
        }
        setOpenLinkDialog(
            {
                list: marketMap[market].filter((fel) => fel.size.barcode === selected || !used[market].has(fel.size.barcode)),
                selected,
                main,
                market
            }
        )
    }, [
        dataWB,
        dataOZON,
    ]);

    const rowVirtualizer = useVirtualizer({
        count: filteredData.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => ROW_HEIGHT,
        overscan: 5,                       // сколько строк рендерить за пределами окна
        getItemKey: (index) => filteredData[index].main.id,   // ключ = id товара
    });

    if (loading) {
      return <Loading/>
    }

    return (
        <Box sx={{height: '100%' }}>    
            <div style={{ height: "5%", display: 'flex', width: '100%', padding: 'calc(2% - 5px) 1% 1% 1%', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{display: "flex", flexDirection: 'row', alignItems: 'center'}}>
                    <ClassicSearch
                        setChecked={setChecked}
                        setFilter={setFilter}
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <Box sx={{
                            zIndex: 10,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            padding: '15px 20px',
                            borderRadius: '10px',
                            minWidth: '250px',
                            height: '36px', 
                            justifyContent: 'center'
                        }}
                    >
                        {loading? <Loading></Loading>:
                        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', flexDirection: "row", justifyContent: 'space-around'}}>
                            <Typography sx={{ fontSize: '12pt', whiteSpace: 'nowrap' }}>
                                SKU: {data.length} шт.
                            </Typography>
                            <IconButton 
                                onClick={() => { setOpenProductDialog(0) }}
                                sx={{ 
                                    position: 'relative',
                                    backgroundColor: "#078476",
                                    borderRadius: '50%',
                                    height:"30px",
                                    width:"30px",
                                    }}
                                disableRipple
                            >
                                <AddIcon
                                    sx={{
                                        color: 'white',
                                        transition: 'all 0.3s ease',
                                        position: 'relative',
                                        '&:hover': hoverStyleTransformOnly,
                                    }}
                                />
                            </IconButton>
                        </Box>
                        }
                    </Box>
                </div>
            </div>
            <div
                ref={parentRef}
                className="custom-scrollbar"
                style={{
                    height: 'calc(100% - 60px)', 
                    overflow: 'auto',
                    width: '100%',
                    borderRadius: '10px',
                    marginTop: '1%',
                }}
            >
                <div
                    style={{
                        height: rowVirtualizer.getTotalSize(),   // ← фантомная высота
                        width: '98%',
                        margin: '0 1%',
                        position: 'relative',
                    }}
                >
                    {rowVirtualizer.getVirtualItems().map((vi) => {
                        const item = filteredData[vi.index];
                        return (
                            <div
                                key={item.main.id}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: ROW_HEIGHT,
                                    transform: `translateY(${vi.start}px)`,
                                }}
                            >
                                <Product
                                    // @ts-ignore
                                    item={item}
                                    editLink={handleEditLink}
                                    editProduct={handleEditProduct}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
            {data && data.length === 0 && 
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    <Button 
                        onClick={preventDoubleClick(() => importFromMarket('wb'), 1000)}    
                        variant="contained" 
                        disabled={dataWB.length === 0}
                        sx={{ 
                            height: "35px", 
                            textTransform: 'none',  
                            fontSize: "18px",
                            borderRadius: "10px",
                            margin: '10px'
                        }}
                    >
                        Импортировать с wb
                    </Button>
                    <Button 
                        onClick={preventDoubleClick(() => importFromMarket('ozon'), 1000)}    
                        variant="contained" 
                        disabled={dataOZON.length === 0}
                        sx={{ 
                            height: "35px", 
                            textTransform: 'none',  
                            fontSize: "18px",
                            borderRadius: "10px",
                            margin: '10px'
                        }}
                    >
                        Импортировать с ozon
                    </Button>
                </div>
            }
            <Dialog
                open={openProductDialog !== undefined}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpenProductDialog(undefined) }}
            >
                <div style={{ height: '600px', width: '700px', overflow: 'hidden'}}>
                    <CreateCustomProduct 
                        CrUp={(inData) => {CUCustomProduct(inData, openProductDialog)}} 
                        cancel={() => setOpenProductDialog(undefined)}
                        // @ts-ignore
                        edit={openProductDialog === 0? undefined: openProductDialog}
                    />
                </div>
            </Dialog>
            <Dialog 
                open={openLinkDialog !== undefined}
                onClose={() => {setOpenLinkDialog(undefined)}}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
            >
                <Box sx={{ height: '600px', width: '700px', overflow: 'hidden'}}>
                    <ChooseProducts 
                        productsData={openLinkDialog?.list || []} 
                        onSelect={(barcode) => saveLink(barcode, openLinkDialog?.main, openLinkDialog?.market)}
                        onCancel={() => setOpenLinkDialog(undefined)}
                        initialBarcode={openLinkDialog?.selected}>
                    </ChooseProducts>
                </Box>
            </Dialog>
        </Box>
    );

}


export const Product = memo( function Product ({ 
    // @ts-ignore
    item, 
    // @ts-ignore
    editLink, 
    // @ts-ignore
    editProduct }) {

    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(undefined)
    const [tab, setTab] = useState("wb")

    const handleChange = (event, newTab) => {
      setTab(newTab);
    };


    useEffect(() => {

        const loadPhoto = async (photoPath) => {
            let tmp = await getFile("png", { path: photoPath }); 
            // @ts-ignore
            setImage(typeof tmp === "string" ? tmp : '')
            setLoading(false)
        }

        if (item.main?.data?.photo && item.main?.data?.photo.startsWith('/app/storage/')) {
            setLoading(true)
            loadPhoto(item.main?.data?.photo)
        }
        else {
            setImage(undefined)
            setLoading(false)
        }
    }, [item]);

    return (
      <div style={{
          width: "96%", 
          display: "flex", 
          flexDirection: "row", 
          alignItems: "stretch", 
          margin: "0% 2% 0% 2%", 
          borderRadius: "10px", 
          backgroundColor: "rgba(255, 255, 255, 0.0)", 
          overflow: "hidden"
          }}
      >
          <div style={{
              width: "30%",
              backgroundColor: '#F5F9FA',//'rgba(255, 255, 255, 0.8)',
              display: "flex",
              flexDirection: "column",
              justifyContent: 'space-between',
              padding: "1%",
          }}>
            <div 
              style={{
                alignContent: "center", 
                display: 'flex', 
                flexDirection: 'row', 
                width: '100%',
                height: 'auto'
              }}
            >
                <style>{`
                .product-link { 
                    color: #000; 
                    text-decoration: none; 
                }
                .product-link:hover { 
                    color: #078376; 
                    text-decoration: underline; 
                }
                `}</style>

                {loading? 
                    <div style={{width:70, height:105}}><Loading/></div>
                    :
                    <ImageFormatProduct value={image || item.main?.data?.photo} />
                }
                
                <div style={{ display: 'flex', flexDirection: 'column', width: "calc(90% - 90px )", marginLeft: '10px', gap: '5px'}}>
                    <Tooltip 
                        title={item.main?.data?.title}
                        slotProps={{
                            popper: {
                                modifiers: [
                                    {
                                    name: 'offset',
                                    options: {
                                        offset: [100, -50], // [горизонталь, вертикаль]. Положительное число отдаляет.
                                    },
                                    },
                                ],
                            },
                        }}
                    >
                        <Typography align='left' 
                            sx={{
                                fontSize: '14pt',
                                fontWeight: 'bold',
                                lineHeight: '14pt',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                          {item.main?.data?.title}
                        </Typography>
                    </Tooltip>
                    <Typography sx={{fontSize: '12pt', lineHeight: '12pt', marginTop: '2px', marginBottom: '2px', fontWeight: 'bold'}}>{item.main?.size?.barcode}</Typography>
                    <Typography sx={{fontSize: '14pt', color: 'gray', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Бренд: {Array.isArray(item.main?.data?.brand)? item.main?.data?.brand.join(', '): item.main?.data?.brand}</Typography>
                    <Typography sx={{fontSize: '14pt', color: 'gray', lineHeight: '14pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Цвет: {Array.isArray(item.main?.data?.color)? item.main?.data?.color.join(', '): item.main?.data?.color}</Typography>
                    {/* {main?.data?.showSize && <Typography variant='subtitle2' align='left'>{main?.data?.showSize}</Typography>} */}
                </div>
            </div>
          </div>
          <div style={{
              width: "10%",
              backgroundColor: '#F5F9FA',
              padding: "1%",
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
          }}>
            {/* теперь там по умолчанию market = custom */}
            <UploadQrButton size={"60%"} value={item.main?.qrcode} desc={undefined} color={iconColor} textColor={iconColor} animate={true}/>
          </div>
          <div style={{
              width: "60%",
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              padding: "1%",
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
          }}>
            <div style={{width: "95%"}}>
                <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                    // "& .MuiTabs-indicator": {
                    //     display: "none"
                    // },
                    margin: '0% 0% 1% 1%',
                    height: "30px",
                    minHeight: "30px"
                }}>

                    <MPTab disableRipple label="WB" value={'wb'}/>
                    <MPTab disableRipple label="OZON" value={'ozon'}/>
                </Tabs>
                <div style={{ height: "calc( 97% - 30px)", display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'}}>
                    {[
                        { label: 'Баркод', value: item[tab]?.size?.barcode },
                        { label: 'Размер', value: item[tab]?.size?.title },
                        { label: 'Артикул', value: item[tab]?.data?.vendorCode },
                    ].map((field, i) => (
                        <div
                            key={i}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '30%',
                                // border: '2px solid',
                                borderColor: item[tab]? buttonColor : warningTextColor,
                                borderRadius: '10px',
                                padding: '4px',
                                boxSizing: 'border-box',                            
                                backgroundColor: 'white'
                            }}
                        >
                            <Typography sx={{ width: "100%", fontSize: '10pt', lineHeight: '12pt', color: '#888' }}>
                                {field.label}
                            </Typography>
                            <Typography sx={{ fontSize: '12pt', lineHeight: '14pt', textAlign: 'center', mt: '10px', mb: '10px'}}>
                                {field.value || "Не указан"}
                            </Typography>
                        </div>
                    ))}
                </div>
            </div>
            <div style={{width: "5%", height: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                <IconButton disableRipple onClick={() => {editProduct(item.main)}} sx={{transition: 'all 0.3s ease', '&:hover': hoverStyle}}>
                    <SettingsIcon sx={{color: buttonColor}}/>
                </IconButton>
                <IconButton disableRipple onClick={() => {editLink(tab, item[tab]?.size?.barcode, item.main?.size?.barcode)}} sx={{transition: 'all 0.3s ease', '&:hover': hoverStyle}}>
                    <img alt="" src={EditIcon} width={25} height={25}/>
                </IconButton>
            </div>
          </div>
      </div>
    )
})

function CreateCustomProduct({CrUp, cancel, edit = undefined}) {
    const [isLoading, setIsLoading] = useState(false);
    
    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    /** @type {[any, Function]} */
    const [data, setData] = useState({
        photo: "",
        blob: "",
        title: '',
        color: [],
        material: [],
        size: '',
        vendorCode: "",
        barcode: undefined,
        url: '',
        brand: '',
        dimensions: {
            length: '',
            height: '',
            width: ''
        },
    })

    const dispatch = useDispatch();
    const { socket } = useContext(SocketContext);
    const onSubmit = useCallback((data) => {
        dispatch(onChangeUploadImage(data));
    }, [dispatch]);
    const { user_id} = useSelector(
        loginSelector
    );


    useEffect(() => {

        const loadPhoto = async (obj) => {
            let photo = await getFile("png", {path:obj.photo});
            if (photo) {
                obj.blob = photo
            }
            setData(obj)
            setIsLoading(false)

        }

        setIsLoading(true)
        if (edit) {
            console.log("edit", edit)
            let obj = {
                // @ts-ignore
                id: edit.size.realId,// @ts-ignore
                nmID: edit.nmID,// @ts-ignore
                photo: edit.data.photo,
                blob: "",// @ts-ignore
                title: edit.data.title,// @ts-ignore
                color: edit.data.color,// @ts-ignore
                material: edit.data.material,// @ts-ignore
                size: edit.size.title,// @ts-ignore
                vendorCode: edit.data.vendorCode,// @ts-ignore
                barcode: edit.size.barcode,// @ts-ignore
                url: edit.data.url,// @ts-ignore
                brand: edit.data.brand,// @ts-ignore
                dimensions: edit.data.dimensions
            }          

            if (obj.photo && obj.photo.startsWith('/app/storage/')) {
                loadPhoto(obj)
            }
            else {//На случай, когда фотка берется с маркета
                obj.blob = obj.photo
                setData(obj)
                setIsLoading(false)
            }
        }
    }, [edit]);

    useOn('uploadCPImage', async ($data) => {
        const photo = await getFile("png", { path: $data.path });
        if (!photo) return;
        setData((prev) => ({ ...prev, photo: $data.path, blob: photo }));
        showNotification({ id: 'uploadCPImageOk', type: 'success', message: 'Изображение загружено' });
    });

    const handleFileUpload = useCallback(async (event, dataPath) => {
        let selectedFiles = Array.from(event.target.files);
        if (selectedFiles && selectedFiles.length > 0) {
          let rightFiles = []
          selectedFiles.map((file) => {
          if (file.type === "image/png" || file.type === "image/jpeg") {
              rightFiles.push(file)
          }
          else {
              showNotification({
              id: 'uploadDealImageErr', // Уникальный идентификатор
              type: 'error', // Тип уведомления
              message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
              });
          }
          })
          if (rightFiles.length > 0 ) {
              onSubmit({ upload: true });
                showNotification({
                id: 'uploadCPImage', // Уникальный идентификатор
                type: 'info', // Тип уведомления
                message: 'Загрузка' // Текст сообщения
              });
              postImage(rightFiles, socket.id, {user_id, role:`custom_product`, content_type:"loadCPImage", dataPath}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
              setIsLoading(true);
          }
        }
        else {
            setIsLoading(false);
        }
    }, [onSubmit]);

    function setPath(path, value) {
        const keys = path.split('.');
        const root = {};
        let cur = root;
        keys.forEach((k, i) => {
            if (i === keys.length - 1) cur[k] = value;
            else cur = (cur[k] = {});
        });
        return root;
    }

    const handleFileDel = async (dataPath) => {
        const old = _.get(data, dataPath);
        setData((prev) => ({ ...prev, blob: undefined, ...setPath(dataPath, '') }));
        if (old) {
            await delFts('/delete-file', { path: [old], taskType: "delImage" }, socket.id);
        }
    };

    const goBind = () => {
        const isValid =true//todo

        if (isValid) {
            CrUp(data)
        } else {
            showNotification({
                id: 'valueError', 
                type: 'error', 
                message: 'Заполните все поля' 
            });
        }
    }

    const cancelProgress = async () => {
        if (!edit) {
            handleFileDel('photo')
        }
        cancel(); 
    }

    const editTextValue = useCallback((path, val) => {
        setData((prev) => {
            const next = { ...prev };
            _.set(next, path, val);   // _.set мутирует next, но next — наша копия
            return next;
        });
    }, []);

    const editNumValue = useCallback((path, val) => {
        const num = parseInt(val, 10);
        if (isNaN(num)) return;
        setData((prev) => {
            const next = { ...prev };
            _.set(next, path, num);
            return next;
        });
    }, []);

    const addNewColor = useCallback(() => {
        setData((prev) => ({ ...prev, color: [...prev.color, ""] }));
    }, []);

    const delColor = useCallback((ind) => {
        setData((prev) => ({
            ...prev,
            color: prev.color.filter((_, i) => i !== ind),
        }));
    }, []);

    const addNewMaterial = useCallback(() => {
        setData((prev) => ({ ...prev, material: [...prev.material, ""] }));
    }, []);

    const delMaterial = useCallback((ind) => {
        setData((prev) => ({
            ...prev,
            material: prev.material.filter((_, i) => i !== ind),
        }));
    }, []);

    console.log("TEST DATA", data)

    return (
        <Box
            sx={{
                height: '100%',
                display: "flex",
                flexDirection: "column",
                p: 1,
                gap: 2,
                overflow: "hidden"
            }}
        >
            <Scrollbars style={{ marginLeft:'10px' }}>
                <div style={{display:"flex", flexDirection: 'column', height: "100%", padding: '10px'}}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        {data.blob? (
                            <div style={{ width: '70px', height: '105px', flexShrink: 0, marginBottom: '10px', position: 'relative' }}>
                                    <img
                                        alt=""
                                        src={data.blob}
                                        style={{
                                            border: '1px solid gray',
                                            borderRadius: '10px',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'fill'
                                        }}
                                    />
                                    {/* Кнопка удаления */}
                                    <IconButton
                                        size="small"
                                        onClick={() => handleFileDel('photo')}
                                        sx={{
                                            position: 'absolute', top: -8, right: -8,
                                            backgroundColor: 'white', boxShadow: 2, width: '24px', height: '24px',
                                            "&:hover": { backgroundColor: "#f0f0f0" }, zIndex: 10
                                        }}
                                    >
                                        <CloseIcon sx={{ fontSize: '16px', color: "red" }} />
                                    </IconButton>
                                    
                                    {/* Скрытый инпут для смены фото кликом */}
                                    <label htmlFor="change-image-edit" style={{ position: 'absolute', inset: 0, cursor: 'pointer', zIndex: 1 }} />
                                    <input
                                        type="file"
                                        accept="image/*"
                                        style={{ display: "none" }}
                                        id="change-image-edit"
                                        onChange={(event) => { handleFileUpload(event, 'photo') }}
                                    />
                                </div>
                            
                            ) : isLoading ? (
                            <div style={{ 
                                width: '70px', 
                                height: '105px', 
                                marginRight: '10px', 
                                display: 'flex', 
                                justifyContent: 'center', 
                                alignItems: 'center', 
                                border: '1px solid lightgray', 
                                borderRadius:'10px' 
                                }}>
                                    <div><Loading/></div>
                                </div>
                            )
                            :
                            <div style={{ width: '70px', height: '105px', marginRight: '10px' }}>
                                <input
                                    type="file"
                                    multiple
                                    accept="application/png"
                                    style={{ display: "none" }}
                                    id="upload-image"
                                    onChange={(event) => {handleFileUpload(event, 'photo')}}
                                />
                                <label 
                                    htmlFor="upload-image" 
                                    style={{ 
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        width: '100%', 
                                        height: '100%',
                                        borderRadius:'10px',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <img 
                                        alt="" 
                                        src={NoPhoto} 
                                        style={{ 
                                            width: '70px', 
                                            height: '105px', 
                                            border: '1px solid gray',
                                            borderRadius: '10px',
                                            objectFit: 'cover'
                                        }}
                                    ></img>
                                </label>
                            </div>
                        }
                        <div style={{width: "calc( 97% - 100px)", height: '105px', marginRight: "2%", display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>
                            <TextInputDesign title={"Название"} val={data?.title} onChange={(e) => editTextValue("title", e)}/>
                            <TextInputDesign title={"Размер"} val={data?.size} onChange={(e) => editTextValue("size", e)}/>
                            <TextInputDesign title={"Артикул"} val={data?.vendorCode} onChange={(e) => editTextValue("vendorCode", e)}/>
                        </div>
                    </div>
                    <div style={{width: "98%", margin: '1% 1% 0 0', display: 'flex', flexDirection: 'column', gap: '20px'}}>
                        <div style={{width: '100%'}}>
                            <div style={{width: '30%'}}>
                                <TextInputDesign title={"Баркод"} val={data?.barcode} onChange={(e) => editTextValue("barcode", e)} maxLength={13} editable={!edit}/>
                            </div>
                            {!edit && <Typography sx={{lineHeight: "10px", fontSize: "10px", color: "red"}}>Если оставить поле пустым, баркод сгенерируется автоматически</Typography>}
                        </div>
                        <TextInputDesign title={"Брэнд"} val={data?.brand} onChange={(e) => editTextValue("brand", e)}/>
                        <TextInputDesign title={"Ссылка на товар"} val={data?.url} onChange={(e) => editTextValue("url", e)}/>
                        <div style={{width: "100%", display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                            <div>
                                <Typography sx={{fontSize: "12pt"}}>Цвет</Typography>
                                <Select
                                    multiple
                                    value={data?.color}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    style={{
                                        width:"300px",
                                        borderRadius: "15px",
                                        fontSize: "15px",
                                        marginRight: "2px",
                                        height: "40px"
                                    }}
                                    renderValue={(selected) => selected.map((el) => el).join(', ')}
                                >
                                    {data?.color && data.color.map((el, index) => (
                                    <MenuItem key={el.id} value={el}>
                                        <div style={{width: '100%', display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                        <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                            <TextInput title={`Цвет ${index+1}`} val={el} onChange={(e) => editTextValue(`color[${index}]`, e)}></TextInput>
                                        </div>
                                        {el.static? <></>: 
                                        <IconButton  aria-label="delImage" onClick={() => {delColor(index)}} 
                                            sx={{
                                            width: 40,
                                            height: 40,
                                            }}
                                        >
                                            <DeleteIcon 
                                                sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                                }
                                            }/>
                                        </IconButton>
                                        }
                                        </div>
                                    </MenuItem>
                                    ))}
                                    <Button onClick={() => addNewColor()}>Добавить</Button>
                                </Select>
                            </div>
                            <div>
                                <Typography sx={{fontSize: '12pt'}}>Материал</Typography>
                                <Select
                                    multiple
                                    value={data?.material}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    style={{
                                        width:"300px",
                                        borderRadius: "15px",
                                        fontSize: "15px",
                                        marginRight: "2px",
                                        height: "40px"
                                    }}
                                    renderValue={(selected) => selected.map((el) => el).join(', ')}
                                >
                                    {data?.material && data.material.map((el, index) => (
                                    <MenuItem key={el.id} value={el}>
                                        <div style={{width: '100%', display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                        <div style={{display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                                            <TextInput title={`Материал ${index+1}`} val={el} onChange={(e) => editTextValue(`material[${index}]`, e)}></TextInput>
                                        </div>
                                        {el.static? <></>: 
                                        <IconButton  aria-label="delImage" onClick={() => {delMaterial(index)}} 
                                            sx={{
                                            width: 40,
                                            height: 40,
                                            }}
                                        >
                                            <DeleteIcon 
                                                sx={{
                                                transition: 'all 0.3s ease',
                                                '&:hover': hoverStyle
                                                }
                                            }/>
                                        </IconButton>
                                        }
                                        </div>
                                    </MenuItem>
                                    ))}
                                    <Button onClick={() => addNewMaterial()}>Добавить</Button>
                                </Select>
                            </div>
                        </div>
                        <NumInputDesign title={"Длина"} val={data?.dimensions.length} onChange={(e) => editNumValue("dimensions.length", e)}/>
                        <NumInputDesign title={"Ширина"} val={data?.dimensions.width} onChange={(e) => editNumValue("dimensions.width", e)}/>
                        <NumInputDesign title={"Высота"} val={data?.dimensions.height} onChange={(e) => editNumValue("dimensions.height", e)}/>
                    </div>
              </div>
            </Scrollbars>

            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    width: 'calc(100% - 20px)',
                    margin: '0px 10px 0px 10px',
                    justifyContent: 'space-between',
                    alignItems: 'flex-end'
                }}
            >
                <CancelButton
                    action={cancelProgress}
                    text={'ОТМЕНА'}
                />
        
                <OKButton
                    action={preventDoubleClick(goBind, 1000)}
                    text={edit? 'СОХРАНИТЬ': "СОЗДАТЬ"}
                />
            </Box>
        </Box>
    );
}